import { Component, ElementRef, Input, Output, EventEmitter } from '@angular/core';
// import { Map, MapView, Extent, SpatialReference, Point } from 'esri-mods';

import { EventsService } from '../../shared/Events.service';
import {ElectionService} from '../../shared/election-service/election.service';
// import { LoadingComponent } from '../../loading/loading.component';
import { SettingsService } from '../../shared/settings/settings.service';
// import {TranslatePipe, TranslateService} from 'ng2-translate/ng2-translate';
import {FormControl, FormGroup} from '@angular/forms';

declare let componentHandler: any;


@Component({
    selector: 'registration-info',
    // templateUrl: 'app/information/registration/registration.component.html'
    template: require('./registration.component.html'),
    // directives: [LoadingComponent],

})
export class RegistrationComponent {

     voterRegistered:boolean = false;
     isVotingResponse:boolean = false;
     voterBirthdate:string
     houseNum:string

     registeredVoterInfo:Array<Object> = [];

    //  voterName: string;
    //  voterAddress: string;
    //  voterCity: string;
    //  voterZip: string;
    //  voterCounty: string;
    //  voterPrecinct: string;
     tabActivated:boolean = false;
     appSettings: Object;
     error: any;

    selectedVoterControl = new FormControl();
    multipleVoters:boolean = false;
    selectedVoter: number = 0;
    selectedVoterObject: Object;

    private selectedAddressSuggestion:Object;


    constructor(private elRef: ElementRef, private _eventsService: EventsService,private _electionService: ElectionService, private _settingsService: SettingsService) { 
        
                _eventsService.selectedAddressObject$.subscribe(address => {
                    //get the current address
                     this.selectedAddressSuggestion = address["addressSuggestion"];
                     //this.selectedAddressSuggestion ? this.selectedFullAddress = this.selectedAddressSuggestion.FullAddress : this.selectedFullAddress = "Address undefined";

                 }
                ); 
                _eventsService.birthdate$.subscribe(birthdate => {
                      //Get the current birthday
                      this.voterBirthdate = birthdate;
                      //initiate the query
                    //   this.voterBirthdate ? this.getRegistration() : console.log("Voter birthday is undefined")
   
                 }
                ); 

                //listen for when a search has been invoked
                _eventsService.searchInvoked$.subscribe(
                    address => {
                        //get the current address
                        this.selectedAddressSuggestion = address["addressSuggestion"];
                        this.voterRegistered = false;

                        this.voterBirthdate ? this.getRegistration() : console.log("Voter birthday is undefined");

                    }

                );

            // Get app settings from settings service      
            this._settingsService.getAppSettings().subscribe(
                settings => { 
                    this.appSettings = settings[0];

                    let currentTabSettings:Object = this.appSettings["widgets"].filter(item => { return item.name === 'Registration'; });
                    this.tabActivated = currentTabSettings[0].activate;
                
                // this.electionServiceURL = this.appSettings["electionServiceURL"];
                },
                err => { this.error = true }
            );
        

    }

    //Retrieve the voter registration info from the service
    getRegistration() {

        // componentHandler.upgradeAllRegistered();

        this.isVotingResponse = true;
        //retrieve from web service
        this._electionService
            .getRegistrationInfo(this.selectedAddressSuggestion["HouseNum"], this.voterBirthdate)
            .then(registration => {

                this.registeredVoterInfo = registration;

                this.voterRegistered = true;

                this.isVotingResponse = false;

                if (this.registeredVoterInfo.length === 1 ) {

                    this.selectedVoterObject = this.registeredVoterInfo[0]

                } else if (this.registeredVoterInfo.length > 1) {

                    this.multipleVoters = true;

                } else {
                    this.voterRegistered = false;
                }
           
                //  componentHandler.upgradeAllRegistered();
            })
            .catch(error => {
                this.error = error;
            this.isVotingResponse = false;
            });
    }

    selectVoter() {
         this.selectedVoterObject = this.registeredVoterInfo[this.selectedVoter];
         this.multipleVoters = false;
    }

    ngOnInit() {
        // create the map
        //this._mapService.createMap(this.itemId, this.elRef.nativeElement.firstChild, this.options).then((response) => {
        //  // get a reference to teh map and expose response to app
        //  this.map = response.map;
        //  this.mapLoaded.next(response);
        //});

            
     
    }

    // destroy map
    ngOnDestroy() {

    }

}


// WEBPACK FOOTER //
// ./app/information/registration/registration.component.ts